<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'Investor Relations',
          to: {
            path: '/investor-relations',
            query: {
              section: $route.query.section,
            },
          },
        },
        {
          name: 'Edit',
          to: {
            path: '/investor-relations/edit',
            query: {
              section: $route.query.section,
            },
          },
        },
      ]"
    ></Breadscrumbs>
    <!-- page actions -->
    <div class="page-actions">
      <h2>Investor Relations</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">
        <span>取消</span>
      </button>
      <button class="btn btn-primary" @click="saveHandler">
        <span>儲存</span>
      </button>
    </div>
    <!-- block 1 -->
    <div class="block" style="margin-bottom: 30px;">
      <PageMenu :sections="sections">
        <component :is="sectionView" :ir="ir"></component>
      </PageMenu>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import PageMenu from '@/components/PageMenu.vue';

import PageTitle from '@/views/I_IR/c/I-0-1-1__IR-Page Title-Edit.vue';
import DefaultMessage from '@/views/I_IR/c/I-0-2-1__IR-Default Messaging-Edit.vue';
import CorporateManagement from '@/views/I_IR/c/I-0-3-1__IR-Corporate Management-Edit.vue';
import FinancialInformation from '@/views/I_IR/c/I-0-4-1__IR-Financial Information-Edit.vue';
import Shareholder from '@/views/I_IR/c/I-0-5-1__IR-Shareholder-Edit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    PageMenu,
    PageTitle,
    DefaultMessage,
    CorporateManagement,
    FinancialInformation,
    Shareholder,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
    sections: [
      {
        name: 'Page Title',
        component: 'PageTitle',
      },
      {
        name: 'Default Message',
        component: 'DefaultMessage',
      },
      {
        name: 'Corporate Governance',
        component: 'CorporateManagement',
      },
      {
        name: 'Financial Information',
        component: 'FinancialInformation',
      },
      {
        name: 'Shareholder',
        component: 'Shareholder',
      },
    ],
  }),
  created() {
    this.getIrInfo();
  },
  computed: {
    ...mapState(['lang']),
    ...mapState('ir', ['ir']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.sections[vm.sectionIndex].component;
    },
  },
  methods: {
    ...mapActions('ir', {
      getIrInfo: 'find',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({
        name: 'IR',
        query: {
          section: this.$route.query.section,
        },
      });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.save(this.ir).then(() => {
          this.$router.push({ name: 'IR' });
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>

<style></style>
